export default __webpack_public_path__ + "packages/tables-chooser/react/tables/categories/dimensions/hierarchy/images/structual-variance-hierarchy.png";